import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import './Stage1Game.css';
import ship1 from '../assets/images/stage1-game/ship1.png';
import ship2 from '../assets/images/stage1-game/ship2.png';
import ship3 from '../assets/images/stage1-game/ship3.png';

import topBar from '../assets/images/stage1-game/topbar.png'
import controllerImage from '../assets/images/stage1-game/controller.png'
import arrowUpImage from '../assets/images/stage1-game/arrow-up.png'
import arrowDownImage from '../assets/images/stage1-game/arrow-down.png'
import levelImage from '../assets/images/stage1-game/level.png'
import bombImage from '../assets/images/stage1-game/bomb.png'
import remove25 from '../assets/images/stage1-game/remove-25.png'
import add50 from '../assets/images/stage1-game/add-50.png'
import add100 from '../assets/images/stage1-game/add-100.png'

import terminal from '../assets/images/stage1-game/terminal.png'

import gameOverTimeout from '../assets/images/stage1-game/success.png'
import gameOverBroken from '../assets/images/stage1-game/drone-broken.png'

const ships = [ ship1, ship2, ship3 ]

const BLOCK_SPLITTER = [ 0.1, 0.4, 0.7, 1.0, 0.7, 0.4, 0.1 ]
const OBJECT_SPLITTER = [ 0.0, 1.0, 0.0 ]
const FADE_OUT_SPACING = 0.35;
const OPACITY_INTERVAL = 300;

function createRandomNumber(min, max) {
    return Math.random() * (max - min) + min;
}

class Stage1Game extends Component {

    btnSound = './sounds/button_sound.mp3';
    decreaseScoreSound = './sounds/decrease-score.mp3';
    increaseScoreSound = './sounds/increase-score.mp3';
    successSound = './sounds/stage1-success.mp3';

    maxHeight = -550;
    minHeight = -60;
    countdownInterval = null;
    bombInterval = null;
    add50Interval = null;
    add100Interval = null;
    remove25Interval = null;
    distanceRatio = 0.625
    
    constructor(props) {
        super(props);
        // console.log(this.props.location.state.shipIndex);
        this.state = {
            shipImage: ships[this.props.location.state === undefined ? 0 : this.props.location.state.shipIndex],
            countdown: 30,
            level: 5,
            playing: false,
            baseSpeed: 6,
            additionSpeed: 0,
            distance: 0,
            score: 100,
            bgOffset: 0,
            itemOffset: 0,
            bombOpacity: 0.0,
            objects: this.createRenderObject(),
            playerVerticalPosition: -250,
            playerHorizontalPosition: 0,
            gameOverTimeout: false,
            gameOverBroken: false,
            add50Opacity: 0.0,
            add100Opacity: 0.0,
            remove25Opacity: 0.0,
            terminalEnable: false,
            distanceInteger: 0
        };

        this.domRefs = {}; // to store dom refs
        this.animateElements = this.animateElements.bind(this);
    }

    startAdd50() {
        if (this.add50Interval !== null) {
            clearInterval(this.add50Interval);
        }
        if (this.add100Interval !== null) {
            clearInterval(this.add100Interval);
            this.setState({
                add100Opacity: 0.0
            })
        }
        if (this.remove25Interval !== null) {
            clearInterval(this.remove25Interval);
            this.setState({
                remove25Opacity: 0.0
            })
        }
        this.setState({
            add50Opacity: 1.0
        });
        this.add50Interval = setInterval(() => {
            if (this.state.add50Opacity >= 0) {
                this.setState({
                    add50Opacity: this.state.add50Opacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.add50Interval)
                this.add50Interval = null
            }
        }, OPACITY_INTERVAL);
    }

    startAdd100() {
        if (this.add50Interval !== null) {
            clearInterval(this.add50Interval);
            this.setState({
                add50Opacity: 0.0
            })
        }
        if (this.add100Interval !== null) {
            clearInterval(this.add100Interval);
        }
        if (this.remove25Interval !== null) {
            clearInterval(this.remove25Interval);
            this.setState({
                remove25Opacity: 0.0
            })
        }
        this.setState({
            add100Opacity: 1.0
        });
        this.add100Interval = setInterval(() => {
            if (this.state.add100Opacity >= 0) {
                this.setState({
                    add100Opacity: this.state.add100Opacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.add100Interval)
                this.add100Interval = null
            }
        }, OPACITY_INTERVAL);
    }

    startRemove25() {
        if (this.add50Interval !== null) {
            clearInterval(this.add50Interval);
            this.setState({
                add50Opacity: 0.0
            })
        }
        if (this.add100Interval !== null) {
            clearInterval(this.add100Interval);
            this.setState({
                add100Opacity: 0.0
            })
        }
        if (this.remove25Interval !== null) {
            clearInterval(this.remove25Interval);
        }
        this.setState({
            remove25Opacity: 1.0
        });
        this.remove25Interval = setInterval(() => {
            if (this.state.remove25Opacity >= 0) {
                this.setState({
                    remove25Opacity: this.state.remove25Opacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.remove25Interval)
                this.remove25Interval = null
            }
        }, OPACITY_INTERVAL);
    }

    startBomb() {
        if (this.bombInterval !== null) {
            clearInterval(this.bombInterval);
        }
        this.bombInterval = setInterval(() => {
            if (this.state.bombOpacity >= 0) {
                this.setState({
                    bombOpacity: this.state.bombOpacity - FADE_OUT_SPACING
                })
            } else {
                clearInterval(this.bombInterval)
            }
        }, OPACITY_INTERVAL);
    }

    checkBatteryToGameOver() {
        if (this.state.level <= 0) {
            this.setState({
                gameOverBroken: true
            });
            this.gameOver();
        }
    }

    createRenderObject() {

        let lastPercent = 3000;
        let obj = [];

        // create oil, from 100%, left distance = 60% ~ 100%, bottom distance = 30% ~ 65%
        let startPercent = 50
        while (startPercent < lastPercent) {
            startPercent += createRandomNumber(80, 150);
            let verDistance = createRandomNumber(5, 65);
            obj.push(this.createOilBottleObject(startPercent.toString() + '%', verDistance.toString() + '%'));
        }

        // create block
        startPercent = 20;
        while (startPercent < lastPercent) {
            startPercent += createRandomNumber(70, 120);
            let mode = createRandomNumber(1, 100);
            let bottomPercent = createRandomNumber(5, 65);
            if (mode % 2 === 0) {
                obj.push(this.createBlock1Object(startPercent.toString() + '%', bottomPercent.toString() + '%'))
                startPercent += createRandomNumber(15, 35);
                obj.push(this.createBlock2Object(startPercent.toString() + '%', bottomPercent.toString() + '%'))
                startPercent += createRandomNumber(15, 35);
                obj.push(this.createBlock3Object(startPercent.toString() + '%', bottomPercent.toString() + '%'))
            } else {
                if (mode < 33) {
                    obj.push(this.createBlock1Object(startPercent.toString() + '%', bottomPercent.toString() + '%'))
                } else if (mode < 66) {
                    obj.push(this.createBlock2Object(startPercent.toString() + '%', bottomPercent.toString() + '%'))
                } else {
                    obj.push(this.createBlock3Object(startPercent.toString() + '%', bottomPercent.toString() + '%'))
                }
            }
        }
        return obj;
    }

    createOilBottleObject(left, bottom) {
        return { 
            bottom: bottom, 
            left: left, 
            touched: false, 
            tag: 2 
        }
    }

    createBlockObject(left, bottom, tag) {
        return { 
            bottom: bottom, 
            left: left, 
            touched: false, 
            delay: false,
            tag: tag
        }
    }

    createBlock1Object(left, bottom) {
        return this.createBlockObject(left, bottom, 3);
    }

    createBlock2Object(left, bottom) {
        return this.createBlockObject(left, bottom, 4);
    }

    createBlock3Object(left, bottom) {
        return this.createBlockObject(left, bottom, 5);
    }

    getBounds(ref) {
        let element = ReactDOM.findDOMNode(ref);
        return (element === null || element === undefined) ? null : ReactDOM.findDOMNode(ref).getBoundingClientRect();
    }

    detectCollision(a, b) {
        if (a === null || b === null) return false;
        return !(
            ((a.y + a.height) < (b.y)) ||
            (a.y > (b.y + b.height)) ||
            ((a.x + a.width) < b.x) ||
            (a.x > (b.x + b.width))
        );
    }

    detectBlockShipCollision(a, b) {
        if (a === null || b === null) return false;
        const elementWidth = b.width / BLOCK_SPLITTER.length;
        for (let i = 0; i < BLOCK_SPLITTER.length; i++) {
            let elementHeight = b.height * BLOCK_SPLITTER[i];
            let element = {
                x: b.x + (elementWidth * i),
                y: b.y + (b.height - elementHeight),
                width: elementWidth,
                height: elementHeight
            }
            if (this.detectCollision(a, element)) {
                return true;
            }
        }
        return false;
    }

    detectObjectCollision(a, b) {
        if (a === null || b === null) return false;
        const elementWidth = b.width / OBJECT_SPLITTER.length;
        for (let i = 0; i < OBJECT_SPLITTER.length; i++) {
            if (OBJECT_SPLITTER[i] > 0) {
                let elementHeight = b.height * OBJECT_SPLITTER[i];
                let element = {
                    x: b.x + (elementWidth * i),
                    y: b.y + (b.height - elementHeight) / 2,
                    width: elementWidth,
                    height: elementHeight
                }
                if (this.detectCollision(a, element)) {
                    return true;
                }
            }
        }
        return false;
    }

    animateElements() {

        let gameSpeed = this.state.baseSpeed + this.state.additionSpeed;

        // increase speed
        // let speed = (this.state.distance / 5) + 5;
        // this.setState({ gameSpeed: speed });

        if (this.state.playing === true) {
            let previousDistance = this.state.distanceInteger;
            this.setState({
                bgOffset: this.state.bgOffset >= window.innerWidth ? 0 : this.state.bgOffset + (0.5 * gameSpeed),
                itemOffset: this.state.itemOffset + (0.625 * gameSpeed),
                distance: this.state.distance + 0.01,
                distanceInteger: Math.floor((this.state.distance + 0.01) * this.distanceRatio)
            });
            if (previousDistance !== this.state.distanceInteger) {
                this.startAdd50();
            }
            let playerRect = this.getBounds(this.refs.player);
            if (playerRect != null) {
                let newState = this.state;
                let changed = false;
                Object.keys(this.state.objects).forEach((item) => {
                    let obj = this.state.objects[item];
                    if (obj != null && obj.touched === false) {
                        let rect = this.getBounds(this.domRefs[item]);
                        if (rect != null) {
                            if (obj.tag === 2) {
                                if (this.detectObjectCollision(playerRect, rect)) {
                                    this.setState({ 
                                        score: this.state.score + 100,
                                        level: this.state.level >= 5 ? 5 : this.state.level + 1
                                    });
                                    this.startAdd100();
                                    this.playIncreaseBtnSound();
                                    newState.objects[item].touched = true;
                                    changed = true;
                                }
                            } else if (obj.tag === 3 || obj.tag === 4 || obj.tag === 5) {
                                if (this.detectBlockShipCollision(playerRect, rect)) {
                                    this.setState({
                                        level: this.state.level - 1,
                                        score: this.state.score - 25,
                                        bombOpacity: 1.0
                                    });
                                    this.startRemove25();
                                    this.playDecreaseBtnSound();
                                    this.startBomb();
                                    newState.objects[item].touched = true;
                                    changed = true;
                                    this.checkBatteryToGameOver();
                                }
                            }
                        }
                    }
                })
                if (changed) {
                    this.setState({ newState })
                }
            }
        }
        requestAnimationFrame(this.animateElements);
    }

    gameOver() {
        this.setState({
            playing: false
        });
        setTimeout(() => {
            this.props.history.push({
                pathname: './stage1-result',
                state: {
                    score: this.state.score < 0 ? 0 : this.state.score,
                    selectedIndex: this.props.location.state.selectedIndex,
                    distance: Math.floor(this.state.distance * this.distanceRatio)
                }
            });
        }, 1000 * 1.5);
    }

    getItemFromTag(tag) {
        if (tag === 2) {
            return 'block-item-can '
        } else if (tag === 3) {
            return 'block-ship-1 '
        } else if (tag === 4) {
            return 'block-ship-2 '
        } else if (tag === 5) {
            return 'block-ship-3 '
        } else {
            return ''
        }
    }

    objectRender(key) {
        let item = this.state.objects[key];
        let styles = {
            transform: 'translate3d(-' + this.state.itemOffset + 'px, 0, 0)', 
            bottom: item.bottom, 
            left: item.left,
        }
        let name = this.getItemFromTag(item.tag)
        if (item.tag === 2) {
            return (
                <div className={name + (this.state.objects[key].touched === true ? 'is-touched' : '')} 
                    key={key} ref={(ref) => {this.domRefs[key] = ref}} style={styles}>
                </div>);
        } else {
            return ( 
                <div className={name + (this.state.objects[key].touched === true ? 'is-touched' : '')} 
                    key={key} ref={(ref) => {this.domRefs[key] = ref}} style={styles}>
                        <div></div>
                </div>);
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions()
        window.addEventListener('keypress', this.keyPress);
        let starting = setInterval(() => {
            let x = this.state.playerHorizontalPosition;
            if (x >= 120) {
                clearInterval(starting);
                this.setState({ playing : true }) 
                requestAnimationFrame(this.animateElements)
            } else {
                this.setState({
                    playerHorizontalPosition: x + 1
                });
            }
        }, 5);
        this.countdownInterval = setInterval(() => {
            if (this.state.countdown === 0) {
                this.setState({
                    gameOverTimeout: true
                });
                this.playSuccessSound();
                this.gameOver();
            } else {
                if (this.state.countdown === 2) {
                    setTimeout(() => {
                        this.setState({
                            terminalEnable: true
                        });
                    }, 700);
                }
                this.setState({
                    countdown: this.state.countdown - 1
                });
            }
        }, 1 * 1000);
    }

    componentWillUnmount() {
        this.setState({ playing : false }) 
        window.removeEventListener('resize', this.updateDimensions);
        window.removeEventListener('keypress', this.keyPress);
        cancelAnimationFrame(this.animateElements)
        clearInterval(this.countdownInterval);  
    }

    keyPress = (event) => {
        if (event.key === 'w') {
            (event).preventDefault();
            this.goUp();
        } else if (event.key === 's') {
            (event).preventDefault();
            this.goDown();
        }
    };

    goUp() {
        if (this.state.playing === true) {
            this.playArrowBtnSound();
            let position = this.state.playerVerticalPosition;
            if (position - 15 >= this.maxHeight) {
                this.setState({
                    playerVerticalPosition: position - 15
                });
            }
        }
    }

    goDown() {
        if (this.state.playing === true) {
            this.playArrowBtnSound();
            let position = this.state.playerVerticalPosition;
            if (position + 15 <= this.minHeight) {
                this.setState({
                    playerVerticalPosition: position + 15
                });
            }
        }
    }

    updateDimensions = () => {
        console.log('width: ' + window.innerWidth);
        console.log('height: ' + window.innerHeight);
        this.setState({
            baseSpeed: window.innerWidth / 160
        });
    };

    playArrowBtnSound() {
        // this.playAudio(this.btnSound);
    }

    playIncreaseBtnSound() {
        this.playAudio(this.increaseScoreSound);
    }

    playDecreaseBtnSound() {
        this.playAudio(this.decreaseScoreSound);
    }

    playSuccessSound() {
        this.playAudio(this.successSound);
    }

    playAudio(filePath) {
        try {
            let btnAudio = new Audio(filePath);
            btnAudio.play();
        } catch (exception) {
            console.log(exception.message);
        }
    }

    render() {
        let bgStyles = { transform: 'translate3d(-' + this.state.bgOffset + 'px, 0, 0)' }

        return (
            <div className='page-root-div' style={{ position: 'fixed', overflow: 'hidden' }}>
                <div className='game-foreground' style={bgStyles}/>
                {Object.keys(this.state.objects).map(key => this.objectRender(key))}
                <div className='ship-player' ref='player' style={{ transform: 'translate3d(' + this.state.playerHorizontalPosition +'%, ' + this.state.playerVerticalPosition + '%, 0)' }}>
                    <img alt='' src={this.state.shipImage} style={{ position: 'absolute', width: '100%', height: '100%', zIndex: '10', objectFit: 'scale-down' }}></img>
                    <img alt='' src={bombImage} style={{ position: 'absolute', width: '80%', height: '80%', zIndex: '11', objectFit: 'scale-down', opacity: this.state.bombOpacity, right: '0px', bottom: '0px' }}></img>
                </div>
                <div style={{ position: 'absolute', width: '14.16%', height: '33.6%', right: '0px', bottom: '0px', zIndex: '1' }}>
                    <img alt='' src={controllerImage} style={{ position: 'absolute', width: '100%' }}></img>
                    <img alt='' className='press-btn' src={arrowUpImage} style={{ position: 'absolute', width: '38%', left: '33%', top: '15%' }} onClick={this.goUp.bind(this)}></img>
                    <img alt='' className='press-btn' src={arrowDownImage} style={{ position: 'absolute', width: '38%', left: '33%', bottom: '15%' }} onClick={this.goDown.bind(this)}></img>
                </div>
                <div style={{ position: 'absolute', right: '0px', top: '0%', height: '17.6%', width: '81.25%' }}>
                    <img alt='' src={topBar} style={{ position: 'absolute', height: '100%', right: '0px' }}></img>
                    <div style={{ position: 'absolute', right: '52.5%', top: '14%', width: '6%', height: '50%', color: '#086940' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="300" fill="#086940" >{Math.floor(this.state.distance * this.distanceRatio)}</text>
                        </svg>
                    </div>
                    <div style={{ position: 'absolute', right: '32%', top: '35%', width: '6%', height: '50%', color: '#086940' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#086940" >{this.state.countdown}</text>
                        </svg>
                    </div>
                    <div style={{ position: 'absolute', left: '12%', top: '22%', width: '6%', height: '50%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="white" >{this.state.score}</text>
                        </svg>
                    </div>
                    <img alt='' src={levelImage} style={{ position: 'absolute', width: '3.8%', right: '21.6%', top: '37%', display: this.state.level > 4 ? 'block' : 'none' }}></img>
                    <img alt='' src={levelImage} style={{ position: 'absolute', width: '3.8%', right: '16.7%', top: '37%', display: this.state.level > 3 ? 'block' : 'none' }}></img>
                    <img alt='' src={levelImage} style={{ position: 'absolute', width: '3.8%', right: '11.8%', top: '37%', display: this.state.level > 2 ? 'block' : 'none' }}></img>
                    <img alt='' src={levelImage} style={{ position: 'absolute', width: '3.8%', right: '6.9%', top: '37%', display: this.state.level > 1 ? 'block' : 'none' }}></img>
                    <img alt='' src={levelImage} style={{ position: 'absolute', width: '3.8%', right: '2%', top: '37%', display: this.state.level > 0 ? 'block' : 'none' }}></img>
                </div>
                <img alt='' src={add50} style={{ position: 'absolute', width: '12.23%', top: '12%', right: '2%', opacity: this.state.add50Opacity }}></img>
                <img alt='' src={add100} style={{ position: 'absolute', width: '12.23%', top: '12%', right: '2%', opacity: this.state.add100Opacity }}></img>
                <img alt='' src={remove25} style={{ position: 'absolute', width: '12.23%', top: '10%', left: '10%', opacity: this.state.remove25Opacity }}></img>
                {
                    this.state.terminalEnable && <img className='terminal' alt='' src={terminal}/>
                }
                {
                    this.state.gameOverBroken && <img alt='' src={gameOverBroken} style={{ width: '40%', left: '30%', top: '25%', position: 'absolute' }}></img>
                }
                {
                    this.state.gameOverTimeout && <img alt='' src={gameOverTimeout} style={{ width: '40%', left: '30%', top: '25%', position: 'absolute' }}></img>
                }
            </div>
        );
    }
}

export default withRouter(Stage1Game);
